import { render, staticRenderFns } from "./categoria.create.vue?vue&type=template&id=1f6efaff&scoped=true&"
import script from "./categoria.create.vue?vue&type=script&lang=js&"
export * from "./categoria.create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6efaff",
  null
  
)

export default component.exports